<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="积分设置" name="first"></el-tab-pane>
      <el-tab-pane label="积分明细" name="second"></el-tab-pane>
      <el-tab-pane label="积分规则" name="points"></el-tab-pane>
      <el-tab-pane label="积分申请记录" name="apply"></el-tab-pane>
    </el-tabs>

    <!--积分设置-->
    <Setting v-if="activeName == 'first'"></Setting>
    <!--积分明细-->
    <Log v-if="activeName == 'second'"></Log>
    <!--积分规则-->
    <Points v-if="activeName == 'points'"></Points>
    <!-- 积分申请记录 -->
    <Apply v-if="activeName == 'apply'"></Apply>
    
  </div>
</template>
<script>
import Setting from './part/Setting';
import Log from './part/Log';
import Points from './part/Points';
import Apply from './part/Apply';
export default {
  components: {
    Setting,
    Log,
    Points,
    Apply
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  created() {
    // 默认
    let tabs = this.$db.getRouteField(this, 'tabs');
    if (tabs) this.activeName = tabs;
  },
  methods: {
    /*切换*/
    handleClick(e) {
      this.activeName = e.name;
      this.$db.setRoute(this, {'tabs': e.name});
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/points/index.vue